var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Cabecalho'),_c('v-content',[_c('Router-View')],1),(!_vm.inicio())?_c('Chat'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }